export const Know_More_IndustryPartner = {
  title:
    "Turn real-world challenges into learning opportunities or connect with us purely to hire execution-ready talent. By partnering with v18hub, you gain access to learners trained on actual problem statements, a pre-vetted talent pipeline built through cohorts you can co-design, and early visibility into candidates before anyone else does.",

  value_points: [
    {
      label: "Co-design cohorts around your problems",
      desc: "Learners work on your actual use cases, not generic simulations.",
    },
    {
      label: "Hire directly from cohort learners",
      desc: "A pre-vetted, execution-tested talent pool you've seen in action.",
    },
    {
      label: "Reduced onboarding costs",
      desc: "Cohort graduates already think in systems, document professionally, and work with modern AI stacks.",
    },
    {
      label: "Early visibility into high-potential talent",
      desc: "Engage before the campus placement cycle and identify the right people early.",
    },
  ],

  how_does_it_work: [
    {
      inner_title: "Register as a Partner",
      inner_desc:
        "Join v18hub as an industry collaborator, whether you want to share real-world challenges, co-design a cohort around your specific problem, or simply connect with execution-ready learners for hiring. Registration gives you access to our cohort ecosystem and a pipeline of tech-ready professionals.",
      img: "/Images/partner_with_us.webp",
      img_alt: "Industry partner or startup founder registering to collaborate with v18hub cohorts",
    },
    {
      inner_title: "Share a Use Case or Hiring Need",
      inner_desc:
        "Choose your mode of collaboration. Submit a real-world problem statement for learners to build against, co-design a cohort around your team's specific domain, or engage purely for hiring by connecting with learners from ongoing or completed cohorts who've been trained on industry-grade problems.",
      img: "/Images/create_project.png",
      img_alt: "Industry partner submitting a real-world AI problem statement or hiring requirement on v18hub",
    },
    {
      inner_title: "Engage with Cohorts",
      inner_desc:
        "Interact with learners and mentors as they work on your problem. Cohorts run through structured weekly milestones, allowing you to review progress, provide technical feedback, and share insights on how learning quality and industry readiness can be improved. \n You can stay involved throughout the cohort or engage during final evaluations based on your preference.",      img: "/Images/industry_partner.jpg",
      img_alt: "Industry partner engaging with AI learners and reviewing project progress on v18hub",
    },
    {
      inner_title: "Continue the Partnership",
      inner_desc:
        "At the end of the cohort, the prototype built by learners is delivered in its current form. \n The partnership can then continue through collaborative development toward a full-scale solution or through direct talent engagement by hiring the trained learners.",
      img: "/Images/track_projects.png",
      img_alt: "Industry partner hiring cohort graduates or continuing AI project development with v18hub",
    },
  ],

  cta: [
    {
      // button1: { label: "Become a Partner", href: "/registration/industry_partner" },
      // button2: { label: "Create Project", href: "/ourcommunity/industry-partners/create-project" },
    },
  ],
};
